import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../../app.config';
import { HelpersService } from '../../../../services/helpers.service';
import { JobcardService } from '../../../../services/jobcard.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { BikeService } from '../../../../services/bike.service';
import { ChecklistService } from '../../../../services/checklist.service';
import { InvoiceService } from '../../../../services/invoice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ServiceRequestService } from 'src/app/services/servicerequest.service';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss'],
})
export class PrintComponent implements OnInit {
  public partnerID: any;
  public partnerData: any;
  public jobcard: any;
  public cyclist: any;
  public bike: any;
  public serviceTypes: any = [];
  public profile: any = {};
  public checklist: any = [];
  public countryData: any = {};
  public displayDateFormat: any = 'dd-MM-yyyy';
  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';

  public url: string = '';
  public quote: any = {};

  private labourProductIds = new Set<number>();

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public jobcardService: JobcardService,
    public cyclistService: CyclistService,
    public checklistService: ChecklistService,
    public bikeService: BikeService,
    private invoiceService: InvoiceService,
    public route: ActivatedRoute,
    public router: Router,
    private translate: TranslateService,
    private serviceRequest: ServiceRequestService
  ) {
    this.profile = this.helpersService.getProfileData();
    this.countryData = this.helpersService.getCountryData();
  }

  ngOnInit() {
    this.translate.setDefaultLang(
      (this.appConfig.getPartnerType() === 'bicycle'
        ? ''
        : this.appConfig.getPartnerType() + '/') +
        (this.profile.Locale ? this.profile.Locale : 'en'),
    );
    this.partnerID = this.helpersService.getPartnerId();
    this.partnerData = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();
    this.displayDateFormat = this.countryData.AngularDateFormat;
    this.displayDateTimeFormat =
      this.countryData.AngularDateFormat +
      ' ' +
      (this.countryData.code == 'US' ? 'hh:mm aa' : 'HH:mm');

    this.getJobCard();
    this.getQuote();
    console.log(this.partnerData);
  }

  getJobCard() {
    this.serviceRequest
      .getServiceRequestData(this.route.snapshot.paramMap.get('id'), true)
      .subscribe((jobcard) => {
        this.jobcard = jobcard;
        this.serviceTypes = this.jobcard.Types.map((type) => {
          return type.TypeDescription;
        }).filter(this.onlyUnique);
        this.checklistService
          .getServiceChecklist(this.partnerID, jobcard.ID)
          .subscribe(
            (checklist) => {
              this.checklist = checklist.filter((x) => {
                return x.mandatoryForAllServices || x.linkedToServiceTypes;
              });
              this.getCyclist();
              this.getBike();
              this.getQRCode();
            },
            (err) => {
              this.getCyclist();
              this.getBike();
            },
          );
      });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  getQRCode() {
    this.jobcardService
      .getJobCardQRIdentifier(this.jobcard.ID)
      .subscribe((result) => {
        this.url =
          window.location.origin +
          '/cyclist/jobcardAttachments/' +
          this.jobcard.ID +
          '?QRCodeIdentifier=' +
          result.qrCodeIdentifier +
          '&Theme=' +
          this.jobcard.PartnerID;
      });
  }

  getCyclist() {
    this.cyclistService
      .getCyclistByIdForPrintSlip(this.jobcard.CyclistID, this.partnerID)
      .subscribe((cyclist) => {
        this.cyclist = cyclist;
      });
  }

  getBike() {
    this.bikeService.getBike(this.jobcard.BikeID).subscribe((bike) => {
      this.bike = bike;
      setTimeout(() => {
        //this.htmltoPDF(); //Fallback option if this does not work for Ridgeway
        window.print();
      }, 1000);
    });
  }

  getQuote() {
    const id = this.route.snapshot.paramMap.get('id');
    this.invoiceService.getInvoice(id, false).subscribe((quote) => {
      this.quote = quote;
    });
    this.serviceRequest.getManageJobCardDetails(Number(id)).subscribe((jobcard: any) => {
      const lineItems: any[] = jobcard?.quote?.lineItems ?? [];
      this.labourProductIds = new Set(
        lineItems
          .filter((li: any) => !!li.MarkedAsLabourProduct)
          .map((li: any) => li.InternalProductID)
      );
    });
  }

  get labourItems(): any[] {
    return (this.quote?.LineItems ?? []).filter((li: any) => this.labourProductIds.has(li.InternalProductID));
  }

  get partsItems(): any[] {
    return (this.quote?.LineItems ?? []).filter((li: any) => !this.labourProductIds.has(li.InternalProductID));
  }

  getStatusDescription() {
    return this.appConfig.getStatusLabel(this.jobcard.StatusID);
  }
}
